import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function RequirePerm({ perm, children }) {
  const { user, can } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (can(perm)) return children;
  return (
    <div data-testid="accesso-negato" className="max-w-md bg-white border border-[#1A2B4A]/10 rounded-lg p-5 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <Lock className="w-4 h-4 text-[#9b2c2c]" />
        <h2 className="font-serif text-xl text-[#1A2B4A]">Accesso non consentito</h2>
      </div>
      <p className="text-sm text-[#4a5568]">
        Questa sezione contiene dati economici dello studio. Chiedi al titolare di abilitare il permesso
        “Vedere importi, onorari, fatture e contabilità” dal pannello Utenti.
      </p>
    </div>
  );
}
